module.exports = "/images/plane-progress.svg?fd19901d5d9c52e1d08c6d2e5a5c088e";